import { render, staticRenderFns } from "./BarCodeReader.vue?vue&type=template&id=a307931c&scoped=true&"
import script from "./BarCodeReader.vue?vue&type=script&lang=js&"
export * from "./BarCodeReader.vue?vue&type=script&lang=js&"
import style0 from "./BarCodeReader.vue?vue&type=style&index=0&id=a307931c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a307931c",
  null
  
)

export default component.exports